<ng-container *ngIf="!showTable; else content">
    <div class="loading text-center">
        <br />
        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
        <br />
        <p>Loading, please wait...</p>
    </div>
</ng-container>

<ng-template #content>
    <!-- <div class="card shadow topSpacing"> -->
    <div class="active-client-container">
        <div class="container-fluid" style="padding: 15px;">

            <div>
                <div class="row container-fluid" style="margin-bottom: 15px;">
                    <div class="col-xs-10 col-sm-10 col-md-4 noPadding">
                        <tag-input [(ngModel)]='clientTags'
                                   [addOnBlur]="true"
                                   (onRemove)="onItemRemoved($event)"
                                   (onAdd)="onItemAdded($event)"
                                   [secondaryPlaceholder]="placeholder"
                                   [placeholder]="placeholder"
                                   [inputId]="'clientTagsInput'"
                                   (onFocus)="onFocusInput()"
                                   [theme]="'foundation-theme'"></tag-input>
                        <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal()">My tags</a>
                    </div>
                    <i style="position: relative;top: 20px;" class="fas fa-search searchIcon" (click)="focusTagsInput('clientTagsInput')"></i>
                    <i style="margin-left: 5px;position: relative;top: 20px;" [popover]="help" class="fas fa-question-circle pointer"></i>
                    <popover-content #help
                                     title="Tags"
                                     placement="right"
                                     [animation]="true"
                                     [closeOnClickOutside]="true">
                        <p>Filter client records by their related tags. Click on tags to add or remove tags from a client.</p>
                    </popover-content>
                </div>
                <div class="row container-fluid">
                    <div class="col-md-8 noPadding">
                        <div>
                            <div class="row">
                                <div class="col-sm-12 col-md-12">
                                    <div class="tags-wrap">
                                        <div *ngFor="let tag of tags; let i = index;" class="tag">
                                            {{tag}}
                                            <span title="Delete" (click)="removeTag(i, $event)">&times;</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--<label style="text-transform: capitalize;" for="iS">Search: </label>-->
                            <div style="margin-top:10px;">
                                <input *ngIf="!showFilterFields" id="iS" type="text" (click)="toggleFilter()" placeholder="Click here to add a filter" />
                                <i *ngIf="!showFilterFields" (click)="toggleFilter()" class="fas fa-search"></i>
                            </div>

                            <div class="cfilter" style="margin-bottom:10px;">
                                <div *ngIf="showFilterFields">
                                    <select #field id="field">
                                        <option value=""></option>
                                        <option *ngFor="let field of fields" value="{{field}}">{{field}}</option>
                                    </select>

                                    <select #filter id="filter">
                                        <option value=""></option>
                                        <option *ngFor="let filter of filters" value="{{filter.value}}">{{filter.text}}</option>
                                    </select>

                                    <input #condition id="condition1" placeholder="Condition" type="text" value="" (keyup.enter)="applyFilter(field.value, filter.value, condition.value)" />

                                    <a (click)="applyFilter(field.value, filter.value, condition.value)">Add</a>

                                </div>
                            </div>

                            <br />
                        </div>
                    </div>

                    <div class="col-md-6 text-right noPadding" style="position: absolute; top:7px; right: 1px;">
                        <div class="btns-container">
                            <a id="addTagsAssessments" (click)="openAddTagsAssessmentsModal()" [ngClass]="{'btn-primary':  rowCount > 0, 'btn-gray': rowCount === undefined || rowCount === 0}" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5">
                                <i class="fas fa-tag text-white-50"> <span class="button-text"> Tags</span></i>
                            </a>
                            <a (click)="openArchiveModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" style="margin-right: 5px;text-align: justify;" [ngClass]="{'btn-primary': canDelete, 'btn-gray': !canDelete}">
                                <i class="fas fa fa-archive text-white-50"> <span class="button-text"> Archive</span></i>
                            </a>
                            <!--<a id="cShowFilter" (click)="toggleFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
                                <i *ngIf="!enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Search</span></i>
                                <i *ngIf="enableFilter" class="fas fa-filter text-white-50"> <span class="button-text"> Hide Search</span></i>
                            </a>-->
                            <a (click)="openConfirmationModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-red': canDelete, 'btn-gray': !canDelete}">
                                <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                            </a>
                            <!--<a (click)="openAssignAssessmentModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-other': canAssign, 'btn-gray': !canAssign}">
                                <i class="fas fa-user-alt text-white-50"> <span class="button-text"> Assign</span></i>
                            </a>-->
                            <!--<a (click)="showImportModal()" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5">
                                <i class="fas fa-file-import text-white-50"> <span class="button-text"> Import</span></i>
                            </a>-->
                            <a (click)="showAddClientModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                <i class="fas fa-plus text-white-50"> <span class="button-text"> Add</span></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="showTable" id="clientsGrid" style="width: 100%; max-height: 380px; height:380px;">
                <ag-grid-angular #agGrid
                                 style="width: 100%; height: 100%;"
                                 class="ag-theme-balham"
                                 [enableFilter]="true"
                                 [floatingFilter]="true"
                                 [gridOptions]="gridOptions"
                                 [rowData]="clients"
                                 [columnDefs]="clientsHeaders"
                                 [enableSorting]="true"
                                 [enableColResize]="true"
                                 (rowClicked)="onRowClicked($event)"
                                 (gridReady)="onGridReady($event)"
                                 [pagination]="true"
                                 [paginationPageSize]="15"
                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                 [rowSelection]="rowSelection"
                                 [suppressRowClickSelection]="true"
                                 (selectionChanged)="onSelectionChangedChoiceSet($event)"
                                 (filterChanged)="filterChanged($event)"
                                 (filterModified)="filterModified($event)">
                </ag-grid-angular>
            </div>
        </div>
        <div style="padding: 0px 15px 15px 15px;margin-top: -15px;">
            <a (click)="showImportModal()" style="text-decoration:underline; cursor:pointer">Import</a>
        </div>
    </div>
    <!-- </div> -->
</ng-template>

<!--/*Add client modal*/-->
<div id="caddClientModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">{{action}} Client</h2>
                <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-3 noPadding">
                        <label><b style="color:#000;">First Name: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-9 noPadding">
                        <input placeholder="First Name" #name (keypress)="_Globals.allowOnlyNumberAndLetters($event)" type="text" value="" id="cname" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-3 noPadding">
                        <label><b style="color:#000;">Last Name: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-9 noPadding">
                        <input placeholder="Last Name" #last (keypress)="_Globals.allowOnlyNumberAndLetters($event)" type="text" value="" id="clast" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-3 noPadding">
                        <label><b style="color:#000;">Email: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-9 noPadding">
                        <input email placeholder="Email" #email (keypress)="preventSpace(email.value, $event, 'cemail')" type="email" value="" id="cemail" />
                        <!--[readonly]="action == 'Edit'" [ngClass]="{'input_readonly': action == 'Edit'}"-->
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button style="margin-right: 20px;" (click)="addClient(email.value, name.value, last.value)" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*import modal*/-->
<div id="importClientsModal" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Import Clients</h2>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="iFile" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-9 col-xs-offset-3 col-sm-10 col-sm-offset-2">
                        <a (click)="downloadImportClientsTemplate()" style="text-decoration:underline; cursor:pointer;">Download template</a>
                    </div>
                </div>

                <div class="row" style="padding-top:10px;">
                    <div class="col-md-12" style="margin-left: 109px;">
                        <div class="checkbox" style="display: contents;">
                            <input (change)="assignAssessmentsStatus()" id="assignAssessments" type="checkbox">
                            <label for="assignAssessments">Assign Assessments</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12" style="padding: 0 25px;">
                        <button (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="okImportClients()" type="button" class="btn btn-primary">{{okImportClientsButton}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="clientConfirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Client(s).</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete these <b>Client(s)</b>?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="delete()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="archiveClientsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Archive Client(s).</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to archive these <b>Client(s)</b>?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="archive()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*modal*/-->
<div id="returnedModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Clients</h2>
                <button type="button" class="close" (click)="closeModalReturned()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <p>{{returnModalMessage}}</p>
                <div style="overflow:auto;max-height: 210px;">
                    <ul>
                        <li *ngFor="let client of returnedClients">{{client}}</li>
                    </ul>
                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeModalReturned()" type="button" class="btn btn-primary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="clientAddTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add tags</h2>
                <button (click)="closeAddTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row container-fluid">
                    <div class="col-xs-2">
                        <span>Tags</span>
                        <i style="margin-left:0;position:relative;top:0;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>
                    <div class="col-xs-8" style="margin-top: -10px;">
                        <tag-input [(ngModel)]='addTags'
                                   [addOnBlur]="true"
                                   (onRemove)="onItemRemoved($event, true)"
                                   (onAdd)="onItemAdded($event, true)"
                                   [secondaryPlaceholder]="placeholder"
                                   [placeholder]="placeholder"
                                   [inputId]="'clientTagsInput'"
                                   (onFocus)="onFocusInput()"
                                   [theme]="'foundation-theme'"></tag-input>
                    </div>
                    <div class="col-xs-2">
                        <i class="fas fa-search searchIcon" style="position: relative; margin-left: -25px; top: 10px;" (click)="focusTagsInput('clientTagsInput')"></i>
                        <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(true)">My tags</a>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeAddTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addClientTags()" [disabled]="auxAddTags.length === 0" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="coachTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeCoachTag(i)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0" style="height: 46.57px; display: flex; align-items: center">
                    <!-- <input type="text" placeholder="Select tags from the table" id="placeholderInput" readonly /> -->
                    <span>Select tags from the table</span>
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="15"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" [disabled]="selectedCoachTags.length === 0" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

